import React, { useEffect, useState, } from 'react';
import useConvertImageToText from '../imageToText';
import './progress.scss';

function convertCentsToDollars(centsString) {
  // Remove commas from the string
  var stringWithoutCommas = centsString.replace(/,/g, '');
  // Convert the string to a number and divide by 100 to get dollars
  var dollars = parseFloat(stringWithoutCommas) / 100;
  // Format the dollars with a dollar sign  
  var formattedDollars = '$' + dollars.toFixed(2);
  return formattedDollars;
}

function trackViewCoupons(retailer) {
  console.log('tracked viewCoupons event')
  window.gtag('event', `Click_${retailer.internal_name}_coupons`, {version: localStorage.getItem("AB_TEST_VARIABLE") || 'N/A'});
}

function ProgressBlock({ user, page, retailer }) {
  const [text, setText] = useState("");
  const siteConfig = page.page;
  const loyalty = siteConfig.components.find((component) => component.block_type === `LoyaltyBlock`);
  // console.log(siteConfig);
  const convertImageToText = useConvertImageToText(page={siteConfig}, retailer);
  let rewards = loyalty.rewards_requirement;

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Call the function returned by the hook, passing the phoneNumber as an argument
        const convertedText = await convertImageToText(user);
        setText(convertedText);
        // setText(convertCentsToDollars(convertedText));
      } catch (error) {
        // Handle error
        console.error('Error fetching converted text', error);
      }
    };
    fetchData();
  }, [user]);

  let textnumber = text.replace('$', '')
  let isRewardGreater = rewards > parseFloat(textnumber);
  let isRewardLess = rewards <= parseFloat(textnumber)
  if (['NaN', 'n/a', '()', '[]'].includes(textnumber.replace(/\s/g,''))) {
    setText('$0');
  }

  return (
    <div className='offer-container'>
      <div className='heading'>You have spent {text}</div>
      {isRewardGreater && <div className='earn-block'>Earn your reward at ${loyalty.rewards_requirement}</div>}
      {isRewardLess && <div className='earn-block'>Your reward has been clipped to your {retailer.internal_name} wallet</div>}
      <div className='clipped-rewards-block'>
        <a
          // href="https://www.publix.com/savings/digital-coupons?mods=Clipped%20Coupons"
          href={retailer.digital_coupons_link}
          onClick={() => trackViewCoupons(retailer)}
          target="_blank" rel="noopener noreferrer"
        >
          Click here
        </a>{" "}
        to see clipped rewards in your {retailer.internal_name} digital wallet.
      </div>
    </div>
  );
}

export default ProgressBlock;